var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationLaptopContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M69.007 46H47.008v2.002h.405v-.001h22.594v.586l-.414.414L66.591 52H47.008v2H67.421l4.587-4.585V46zM50 10h14c1.103 0 2 .897 2 2v32h2V12c0-2.206-1.794-4-4-4H47v2h3zM30 46H8v3.414L12.586 54h20.413v-2H13.414l-3-3-.414-.414V48h22.586l.001.002h.412V46H31z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M30 12H16v32h16.999L33 42H18V14h35v-2H31z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M50 12h14v32H47.001L47 42h15V14H27v-2h22z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M20 24h24v-2H20zM20 28h13v-2H20zM20 18h24v-2H20z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 8H16c-2.206 0-4 1.794-4 4v32h2V12c0-1.103.897-2 2-2h37V8H30z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 66h-6v1.001c0 .353.072.686.184 1.001A2.997 2.997 0 0040 70.004c1.302 0 2.401-.84 2.816-2.002.112-.315.184-.648.184-1.001V66zm0-18V38h-2v26h2V48zm0-12.991v-1.698l-.869-1.305-.666-1.001-.667-1.001L40 28.806l-.798 1.198-.667 1.001-.666 1.001L37 33.311v2.699h6v-1.001zm-6 3.989V64h2V38h-2v.998zm6.975 31.063c-.288.38-.624.716-1.006 1.001A4.953 4.953 0 0140 72.063a4.953 4.953 0 01-2.969-1.001 5.048 5.048 0 01-1.006-1.001 4.973 4.973 0 01-.924-2.002A5.005 5.005 0 0135 67.058V33.007c0-.197.059-.391.168-.555l.297-.446.666-1.001.667-1.001 2.37-3.558c.186-.278.498-.446.832-.446.334 0 .646.168.832.446l2.37 3.558.667 1.001.666 1.001.297.446c.109.164.168.358.168.555v34.051c0 .343-.035.677-.101 1.001a4.973 4.973 0 01-.924 2.002z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }))));
}

export default SvgIconIllustrationLaptopContent;